// removed by extract-text-webpack-plugin
module.exports = {"cover-shadow":"_15fK6whxg7Wbv2Lx7B71aN _3jblqlydyeJqpKzpSv89pq","mobile-price":"_1Lu08pwsgMVwjttd4xXF1E","mobile-sale-price":"_2DMOTYHzKlCPLRjPVWE_5B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/PriceBar.scss
// module id = 631
// module chunks = 47